/* eslint-disable */
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers'
import { setToken } from './utils/util';

try {
  let is = window.__INITIAL_STATE__;
  if (is) {
    initialState = is;
  }
  delete window.__INITIAL_STATE__;
} catch (e) {
}

let _callbacks = []
function _procCallbacks() {
  for (let cb of _callbacks) {
    cb();
  }
  _callbacks = [];
}

function sortByName(l) {
  if (!l) {
    return l;
  }
  l.sort((a, b) => a.name.localeCompare(b.name));
  return l;
}

function reducer(state = {
  isLoggedIn: false,
  suppliers: [],
  locations: [],
  orders: [],
  orderSuppliers: [],
  errors: {},
  quoteRequest: {},
  search: {},
  category: {},

  get: {},
  list: {},
}, action) {
  console.log('ACTION', action);

  let newState = Object.assign({}, state);
  let loadingCount = state.loadingCount || 0;

  let applySuccess = (delta) => {
    if (!(delta.options && delta.options.silent)) {
      loadingCount--;
    }
    newState = Object.assign({}, newState, delta);
  };

  let applySaveSuccess = (field, obj) => {
    loadingCount--;
    let existing = state[field] || [];
    let found = -1;
    for (let i = 0; i < existing.length; i++) {
      if (existing[i].id === obj.id) {
        found = i;
        break;
      }
    }
    let updated = [];
    for (let i = 0; i < existing.length; i++) {
      updated[i] = existing[i];
    }
    if (found == -1) {
      updated.push(obj);
    } else {
      updated[found] = obj;
    }

    let delta = {};
    delta[field] = updated;
    newState = Object.assign({}, newState, delta);
  };

  let applySaveSuccess2 = (field, obj, options) => {
    if (!(options && options.silent)) {
      loadingCount--;
    }

    // Determine update to list
    let existing = state.list[field] || { items: [], count: 0 };
    let found = -1;
    for (let i = 0; i < existing.items.length; i++) {
      if (existing.items[i].id === obj.id) {
        found = i;
        break;
      }
    }
    let updated = { items: [] };
    for (let i = 0; i < existing.items.length; i++) {
      updated.items[i] = existing.items[i];
    }
    if (found == -1) {
      updated.items.push(obj);
    } else {
      updated.items[found] = obj;
    }
    updated.count = updated.items.length;

    let delta = { list: Object.assign({}, state.list) };
    delta.list[field] = updated;

    // Determine update to get
    if (state.get[field] && state.get[field].id == obj.id) {
      delta.get = Object.assign({}, state.get);
      delta.get[field] = Object.assign({}, obj);
    }

    newState = Object.assign({}, newState, delta);
  };

  let applyDeleteSuccess = (field, id, options) => {
    if (!options.silent) {
      loadingCount--;
    }

    // Determine delete for list
    let existing = state.list[field] || { items: [], count: 0 };
    let updated = { items: [] };
    let found = -1;
    for (let i = 0; i < existing.items.length; i++) {
      if (existing.items[i].id !== parseInt(id)) {
        updated.items.push(existing.items[i]);
      }
    }
    updated.count = updated.items.length;

    let delta = { list: Object.assign({}, state.list) };
    delta.list[field] = updated;

    // Determine delete for get
    if (state.get[field] && state.get[field].id == obj.id) {
      delta.get = Object.assign({}, state.get);
      delete delta.get[field];
    }

    newState = Object.assign({}, newState, delta);
  };

  let updateActiveJobs = () => {
    if (!newState.jobs) {
      return;
    }
    
    let active = [];
    for (let job of newState.jobs) {
      if (job.workflow === 'active') {
        active.push(job)
      }
    }
    newState = Object.assign({}, newState, { activeJobs: active });
  };

  let errors;
  let delta;
  let results;

  switch (action.type) {
    case '@@redux/INIT':
      try {
        let is = window.__INITIAL_STATE__;
        if (is) {
          newState = is;
        }
        delete window.__INITIAL_STATE__;
      } catch (e) {
      }
      try {
        newState.alreadyEscaped = JSON.parse(localStorage.getItem('alreadyEscaped') || '{}');
      } catch (e) {
        newState.alreadyEscaped = {};
      }
      break;

    case 'SET_TOKEN':
      newState = Object.assign({}, newState, { token: action.token });
      break;

    case 'FETCH_USER_START':
      if (!(action.options && action.options.silent)) {
        loadingCount++;
      }
      break;
    case 'FETCH_USER_SUCCESS':
      applySuccess({
        user: action.user,
        isLoggedIn: action.isLoggedIn,
        view: action.user && action.user.profile && action.user.profile.type,
        options: action.options,
      });
      break;

    case 'ALREADY_ESCAPED':
      newState = Object.assign({}, newState, { alreadyEscaped: action.obj });
      break;

    case 'POST_ERROR':
    case 'UPDATE_ERROR':
    case 'CREATE_ERROR':
    case 'SET_ERROR':
      loadingCount--;
      errors = Object.assign({}, state.errors);
      errors[action.key] = action.error;
      newState = Object.assign({}, newState, { errors: errors });
      break;

    case 'UPLOAD_START':
      if (!(action.options && action.options.silent)) {
        loadingCount++;
      }
      break;
    case 'UPLOAD_SUCCESS':
      if (!(action.options && action.options.silent)) {
        loadingCount--;
      }
      break;


    default:
      if (action.type.startsWith('GET_')) {
        if (action.type.endsWith('_START')) {
          if (!action.options.background && !action.options.local) {
            delete state.get[action.key];
          }
          if (!action.options.silent) {
            loadingCount++;
          }
        } else if (action.type.endsWith('_SUCCESS')) {
          state.get[action.key] = action.obj;
          state.get[action.key]._from = action.from;
          if (!action.options.silent) {
            loadingCount--;
          }
        } else {
          console.error('Unhandled get result', action.type, action);
        }
      } else if (action.type.startsWith('POST_')) {
        if (action.type.endsWith('_START')) {
          delete state.get[action.key];
          if (!action.options.silent) {
            loadingCount++;
          }
          errors = Object.assign({}, state.errors);
          delete errors[action.key];
          newState = Object.assign({}, newState, { errors: errors });
        } else if (action.type.endsWith('_SUCCESS')) {
          if (!action.options.silent) {
            loadingCount--;
          }
        } else {
          console.error('Unhandled get result', action.type, action);
        }
      } else if (action.type.startsWith('LIST_')) {
        if (action.type.endsWith('_START')) {
          if (!action.options.background && !action.options.incr && !action.options.local) {
            delete state.list[action.key];
          }
          delta = {};

          let loadingDelta = {};
          let existingValue = { count: 0, ref: {} };
          if (state.loadingParts && state.loadingParts[action.key]) {
            existingValue = state.loadingParts[action.key];
          }
          let value = Object.assign({}, existingValue);
          value.count = value.count + 1
          if (action.options.ref) {
            value.ref[action.options.ref] = true;
          }
          loadingDelta[action.key] = value;
          delta = {};
          delta.loadingParts = Object.assign({}, state.loadingParts, loadingDelta);
          console.log('incr delta.loadingParts', delta.loadingParts);
          newState = Object.assign({}, newState, delta);

          if (!action.options.silent) {
            loadingCount++;
          }
        } else if (action.type.endsWith('_SUCCESS')) {
          if (action.options.incr) {
            let items = state.list[action.key] ? state.list[action.key].items : [];
            let count = state.list[action.key] ? state.list[action.key].count : action.count;
            state.list[action.key] = {
              items: items.concat(action.items),
              count: count,
              _from: action.from,
            };
          } else if (!action.options.local) {
            state.list[action.key] = {
              items: action.items,
              count: action.count,
              _from: action.from,
            };
          }

          let loadingDelta = {};
          let existingValue = state.loadingParts[action.key];
          let value = Object.assign({}, existingValue);
          value.count = value.count - 1;
          let prevLoadingParts = state.loadingParts;
          if (value.count) {
            loadingDelta[action.key] = value;
          } else {
            delete loadingDelta[action.key];
            delete prevLoadingParts[action.key];
          }
          delta = {};
          delta.loadingParts = Object.assign({}, prevLoadingParts, loadingDelta);
          newState = Object.assign({}, newState, delta);

          if (!action.options.silent) {
            loadingCount--;
          }
        } else {
          console.error('Unhandled get result', action.type, action);
        }
      } else if (action.type.startsWith('CREATE_')) {
        if (action.type.endsWith('_START')) {
          if (!action.options.silent) {
            loadingCount++;
          }
          errors = Object.assign({}, state.errors);
          delete errors[action.key];
          newState = Object.assign({}, newState, { errors: errors });
        } else if (action.type.endsWith('_SUCCESS')) {
          applySaveSuccess2(action.key, action.obj, action.options);
        } else {
          console.error('Unhandled get result', action.type, action);
        }
      } else if (action.type.startsWith('DELETE_')) {
        if (action.type.endsWith('_START')) {
          if (!action.options.silent) {
            loadingCount++;
          }
        } else if (action.type.endsWith('_SUCCESS')) {
          applyDeleteSuccess(action.key, action.id, action.options);
        } else {
          console.error('Unhandled get result', action.type, action);
        }
      } else if (action.type.startsWith('UPDATE_')) {
        if (action.type.endsWith('_START')) {
          if (!action.options.silent) {
            loadingCount++;
          }
          errors = Object.assign({}, state.errors);
          delete errors[action.key];
          newState = Object.assign({}, newState, { errors: errors });
        } else if (action.type.endsWith('_SUCCESS')) {
          applySaveSuccess2(action.key, action.obj, action.options);
        } else {
          console.error('Unhandled get result', action.type, action);
        }
      } else {
        console.error('Unhandled action', action.type, action);
      }
  }
  newState = Object.assign(newState, {
    loading: loadingCount > 0,
    loadingCount: loadingCount,
  });
  // console.log('Old loading count:', state.loadingCount);
  // console.log('New loading count:', newState.loadingCount);
  console.log('New state', newState);

  return newState;
}

export function create() {
  return createStore(reducer, applyMiddleware(thunk));
}

export let store = create();



/** WEBPACK FOOTER **
 ** ./src/store.js
 **/